import { $, html, View } from 'rune-ts';
import { BeforeRenderError, RequiredValueEmptyError } from '../../../error';
import { getSharedData } from '../../../util';
import { Icon } from '../Icon/Icon';
import type { Typo } from '../Typo/Typo';
import klass from './Checkbox.module.scss';

export interface CheckboxData {
  name: string;
  label?: Typo;
  disabled?: boolean;
  active?: boolean;
}

export class Checkbox extends View<CheckboxData> {
  input_element?: HTMLInputElement;

  override template() {
    const { name, disabled, active, label } = this.data;
    const theme = getSharedData(this).theme;

    if (!name) {
      throw new RequiredValueEmptyError(this, 'data.name');
    }

    return html` <label class="${klass.button_checkbox}">
      <input
        class="${klass.checkbox}"
        ${disabled ? 'disabled' : ''}
        ${active ? 'checked' : ''}
        type="checkbox"
        name="${name}"
      />
      <span class="${klass.button_wrapper}">
        <span class="${klass.button}">
          <span class="${klass.check}">${new Icon({ name: 'check', size: theme === 'Marpple' ? 12 : 16 })}</span>
        </span>
        ${label}
      </span>
    </label>`;
  }

  protected override onRender() {
    this.input_element = $(this.element()).find('input[type="checkbox"]')?.element() as HTMLInputElement;
    this.delegate('change', 'input[type="checkbox"]', this.changeActive);
  }

  private changeActive() {
    this.data.active = !!this.input_element?.checked;
  }

  activate() {
    if (!this.input_element) {
      throw new BeforeRenderError(this);
    }

    if (this.input_element?.checked) {
      return;
    }

    if (this.input_element) {
      this.input_element.checked = true;
      this.data.active = true;
    }
  }

  deactivate() {
    if (!this.input_element) {
      throw new BeforeRenderError(this);
    }

    if (!this.input_element?.checked) {
      return;
    }

    if (this.input_element) {
      this.input_element.checked = false;
      this.data.active = false;
    }
  }

  isChecked() {
    return this.data.active ?? false;
  }
}
